import {
    GET_MEDIA,
    GET_MEDIA_SUCCESS,
    GET_MEDIA_FAILED
} from './actionTypes';

const initialState = {
    error: "",
    loading: false,
    media: undefined
}

const campaign = (state = initialState, action) => {
    switch (action.type) {
        case GET_MEDIA:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_MEDIA_SUCCESS:
            state = {
                ...state,
                loading: false,
                media: action.payload
            }
            break;
        case GET_MEDIA_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default campaign;